export const MODAL_OPTIONS = [
  {
    id: 'save-image',
    title: '첨부파일 저장하기',
    titleColor: '#000',
    children: [
      {
        text: '게시글 첨부파일 전체 저장',
        color: '#898989',
      },
      {
        text: '이 첨부파일만 저장',
        color: '#898989',
      },
    ],
  },
];
